define('module/newsletter-popup',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub',
    'util/cookie'
], function($, _, Cnf, Pubsub, Cookie) {
    'use strict';

    /**
     * handle newsletter popup
     * 
     * @jira FDZ-677
     * @jira FDZ-714
     * 
     * @date 2023-07-27
     * @updated 2023-10-20
     * @author sh@sopg.de
     */
    
    return function()
    {
        var oPubsub=new Pubsub;

        this.cnf = {
            selector: {
                el: '.newsletter-popup',
                close: '.close'
            }
        };

        /**
         * main entry
         */
        this.init = function()
        {
            this.initElement();
            this.initEvent();
        }

        /**
         * init element
         */
        this.initElement = function()
        {
            this.$el = Cnf.$app.find(this.cnf.selector.el);
            this.$close = this.$el.find(this.cnf.selector.close);
        }

        /**
         * init event
         */
        this.initEvent = function()
        {
            if(this.$el.length <=0) {
                return;
            }

            this.sCookieName = 'nl-popup-' + this.$el.data('type');

            //add listener only if no appropriate cookie is given
            if(!Cookie.get(this.sCookieName)) {
                _.delay(_.bind(this.show, this), 3000);

                this.$close.on('click', _.bind(this.setCookieAndHide, this, 0));

                oPubsub.on(Pubsub.HIDE_NL_POPUP,_.bind(this.setCookieAndHide,this));
            }
        }

        /**
         * show popup
         * 
         * @jira FDZ-677
         * 
         * @date 2023-07-27
         * @author sh@sopg.de
         */
        this.show = function()
        {
            this.$el.attr('data-show', 'true');
        }

        /**
         * hide popup
         * 
         * @jira FDZ-677
         * 
         * @date 2023-07-27
         * @author sh@sopg.de
         * 
         * @param {object} ev 
         */
        this.hide = function(ev)
        {
            if(typeof ev === 'object') {
                ev.preventDefault();
            }

            this.$el.attr('data-show', 'false');
        }

        /**
         * set cookie && hide popup
         * 
         * @jira FDZ-677
         * @jira FDZ-714
         * 
         * @date 2023-07-27
         * @updated 2023-10-20
         * @author sh@sopg.de
         * 
         * @param {int} delay
         * @param {object} ev 
         */
        this.setCookieAndHide = function(delay, ev)
        {
            if(typeof ev === 'object') {
                ev.preventDefault();
            }

            //set default delay if not given
            if(typeof delay !== 'number') {
                delay = 15000;
            }

            Cookie.set(this.sCookieName, true);
            _.delay(_.bind(this.hide, this), delay);
        }

        this.init();
    };
});
